import React from "react";
import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";
// import FontIcon from "react-md/lib/FontIcons";
import { map, forEach, filter, isEmpty } from "lodash";
import {TouchTable, TouchTable_alignColumnRight} from "../../AtollonTheme/ReactElements";
import Buttons from "../Buttons";
import { Button, FontIcon } from "react-md";


const Projects = ( props ) => {

  let { history, projects, searchBar } = props;


  let headerAsList = [];
  let elementsAsList = [];

  if( projects )
  {
    headerAsList = ['Název', TouchTable_alignColumnRight( "Akce" )];
    const projectsArray = projects.item;
    const foundProjectsAsArray = filter(
        projectsArray,
        item => {
            if( searchBar && searchBar.searchText )
            {
                let matches = ( string ) => {
                    return string.toLocaleLowerCase().match( searchBar.searchText.toLocaleLowerCase() );
                };
                let match = matches( item.name );
                return match;
            }
            else
            {
                return true;
            }
        }
    );
    forEach( foundProjectsAsArray,
        c => {
        elementsAsList.push([
            <div>{c.name}</div>,
            <Button flat onClick={() => history.push(`/projects/${c.identifier}`)} className={"btn touchButton-3"}>Detail</Button>
        ]);
    });
  }
  return (

    <div>
        <TouchTable
            headerAsList={headerAsList}
            elementsAsList={elementsAsList}
        />
        <div className="flex-row flex-centered">
        </div>
    </div>
  );
};

export default Projects;



// WEBPACK FOOTER //
// ./src/components/projects/List.js